<template>
  <div class="Xkzbox">
    <XKZ />
  </div>
</template>
<script>
import XKZ from "@/components/XKZ.vue";
export default {
  components: { XKZ },
  data() {
    return {};
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.Xkzbox {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background-color: #efefef;
  overflow-y: scroll;
}
</style>